var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddFloor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 24 24",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsVectornator: "http://vectornator.io",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer-1",
    vectornatorLayerName: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.60814 19.2217L7.7681 19.2438L7.83125 14.1105L12.8982 14.0466L12.8785 9.36722L17.5643 9.31879L17.5507 4.76258L22.7198 4.71279",
    fill: "none",
    opacity: 1,
    stroke: "#f56400",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07968 7.66338L9.55316 7.67739",
    fill: "none",
    opacity: 1,
    stroke: "#f56400",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82702 10.3759L6.83973 4.91507",
    fill: "none",
    opacity: 1,
    stroke: "#f56400",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFloor);
export default __webpack_public_path__ + "static/media/add_floor.483229b85d8a792d789391d69f7032e4.svg";
export { ForwardRef as ReactComponent };